import React, { Component } from 'react';
import { withTranslation } from '../../lib/translate.js';
import { deepIsDefined, isDefined } from '../../lib/utils.js';
import { connect } from 'react-redux';
import Basket from '../../lib/basket.js';
import { getConfig } from '../../appConfig.js';
import Incrementer from '../incrementer/index.js';
import './index.css';
import { NormalText, SmallText, StrongText } from '../common/index.js';
import { IonButton } from '@ionic/react';

class PointsRedeemBox extends Component {
	constructor(props) {
		super(props);
		this.state = {
			points: Basket.getAppliedPoints(),
		};
	}
	componentDidMount() {
		const points = Basket.getAppliedPoints();
		if (points > 0) {
			this.setState({ points });
		}
	}
	getRedeemPointsMin = () => parseInt(getConfig().general.redeemPointsMin) || 50;

	getDefaultPoints = () => {
		const minimumPoints = this.getRedeemPointsMin();
		const availableBalance = this.props.availableBalance;
		const orderValue = Basket.calculatePointsFromPrice(Basket.getTotal()) + Basket.getAppliedPoints();
		let defaultPoints = 0;
		if (availableBalance >= minimumPoints && orderValue >= minimumPoints) {
			defaultPoints = availableBalance > orderValue ? orderValue : availableBalance;
		}
		return defaultPoints;
	};
	onIncrementerUpdate = (points) => {
		if (points < this.state.points && points < this.getRedeemPointsMin()) {
			points = 0;
		}
		if (points > this.state.points && points < this.getRedeemPointsMin()) {
			points = this.getRedeemPointsMin();
		}
		const shouldScroll = this.state.points == 0 && points !== 0;
		this.setState({ points }, () => {
			Basket.applyPoints(points, this.props.availableBalance);
		});
	};
	render() {
		const { __ } = this.props;
		let availableBalance = this.props.availableBalance;
		const points = Basket.getAppliedPoints();
		const step = getConfig().general.redeemPointsStep || 50;
		const basketTotalInCents = Basket.calculatePointsFromPrice(Basket.getTotal()) + Basket.getAppliedPoints();
		let limit = 0;
		if (!isDefined(availableBalance) && availableBalance === null) {
			availableBalance = 0;
		} else {
			limit = parseInt(availableBalance / step) * step;
		}
		let pointsLimitBasedOnBasket = basketTotalInCents;
		if (pointsLimitBasedOnBasket > 0) {
			if (basketTotalInCents <= availableBalance) {
				limit = basketTotalInCents;
			} else {
				pointsLimitBasedOnBasket = parseInt(pointsLimitBasedOnBasket / step) * step;
			}
		}
		return (
			<div className="points-redeem-box-wrapper ">
				<div>
					<SmallText>{`${__('You have')} ${availableBalance} ${__('loyalty points')}`}</SmallText>
					<SmallText onClick={() => this.onIncrementerUpdate(this.getDefaultPoints())} className="primary-color link">
						{__('apply max')}
					</SmallText>
				</div>
				<div className='item-content-actions'>
					<Incrementer
						maxLimit={this.getDefaultPoints()}
						onUpdate={this.onIncrementerUpdate}
						quantity={points}
						step={step}
						allowNegative={false}
						minLimit={0}
					>

						{`${points} ${__('points')}`}
					</Incrementer>
					<StrongText>{Basket.formatPrice(Basket.calculatePointsAppliedPrice(null, true), true)}</StrongText>
				</div>
			</div>
		);
	}
}

const mapStateToProps = (store) => {
	return {
		basketUpdated:store.orders.basketUpdated,
		availableBalance: deepIsDefined(store, 'profile.profile.available_balance') ? store.profile.profile.available_balance : 0,
	};
};
export default connect(mapStateToProps)(withTranslation(PointsRedeemBox));
